var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"feature-card-container",class:_vm.rootClassName},[_c('img',{staticClass:"feature-card-image",attrs:{"alt":_vm.image_alt,"src":_vm.image_src}}),_c('h5',{staticClass:"Headline5 feature-card-text"},[_vm._v(_vm._s(_vm.card_title))]),_c('span',{staticClass:"feature-card-text1"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }